import { render, staticRenderFns } from "./subjectKnowledgeAbility.vue?vue&type=template&id=2bb50ec7&scoped=true"
import script from "./subjectKnowledgeAbility.vue?vue&type=script&lang=js"
export * from "./subjectKnowledgeAbility.vue?vue&type=script&lang=js"
import style0 from "./subjectKnowledgeAbility.vue?vue&type=style&index=0&id=2bb50ec7&prod&lang=scss&scoped=true"
import style1 from "./subjectKnowledgeAbility.vue?vue&type=style&index=1&id=2bb50ec7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb50ec7",
  null
  
)

export default component.exports